import { Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { SupplierDetail } from '../supplier-detail';
import { SupplierDetailDto } from '../dto/supplier-detail-dto';
import { mapAddress } from './address-mapper';
import { mapBonusCondition } from './bonus-condition-mapper';

export const mapSupplierDetail = (locales: Locale[], supplier: SupplierDetailDto): SupplierDetail => ({
    id: supplier.id,
    name: supplier.name,
    image: supplier.image,
    conditions: supplier.conditions?.map(condition => mapBonusCondition(condition)) ?? [],
    conditionsOfPurchase: supplier.conditionsOfPurchase,
    isChargingSupplier: supplier.isChargingSupplier,
    termsOfDelivery: supplier.termsOfDelivery,
    paymentTerm: getLocalizedString(locales, supplier.paymentTerm?.text),
    address: mapAddress(supplier.address),
    email: supplier.email,
    phone: supplier.phone,
    documents: supplier.documents ?? [],
    url: supplier.url,
    placeOfJurisdiction: supplier.placeOfJurisdiction,
    registerNumber: supplier.registerNumber,
    uid: supplier.uid,
    mainContact: supplier.mainContact,
});
